import { defineMessages } from 'react-intl';

export const i18n: {
	threadTitleWithOthers: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	groupChatTitle: {
		id: string;
		defaultMessage: string;
	};
	groupMeetingTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	externalPeopleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	externalPersonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unknownChannel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	directMessageSingleUser: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	directMessageTwoUsers: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	groupDirectMessageUnknownNames: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	federatedGroupDirectMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	federatedGroupDirectMessageWithOneOther: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	federatedGroupDirectMessageWithMultipleOthers: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	threadTitleWithOthers: {
		id: 'search-result.thread-title-with-others-and-channel-name',
		// eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
		defaultMessage: ` {contributorCount, plural,
				=0 {}
				=1 {{name1} in }
				=2 {{name1} and {name2} in }
				=3 {{name1}, {name2}, and {name3} in }
				=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in }
				other {{name1}, {name2}, {name3}, and {overflowContributorCount} others in }
			}#{channelName} `,
		description:
			'The title of a thread in a search result to include many others. For example, "Alice, Bob, Charlie and 5 others in #announcements"',
	},
	groupChatTitle: {
		id: 'search-result.group-chat-title',
		description:
			'Title for a group chat thread in search results. Shows contributor names based on count; {name1}, {name2}, {name3} are user display names, {overflowContributorCount} is the number of additional participants.',
		// eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
		defaultMessage: ` {contributorCount, plural,
				=0 {Group message with external users}
				=1 {{name1}}
				=2 {{name1} and {name2}}
				=3 {{name1}, {name2}, and {name3}}
				=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other}
				other {{name1}, {name2}, {name3}, and {overflowContributorCount} others}
			} `,
	},
	groupMeetingTitle: {
		id: 'search-result.group-meeting-title',
		// eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
		defaultMessage: ` {contributorCount, plural,
				=0 {}
				=1 {{name1} in }
				=2 {{name1} and {name2} in }
				=3 {{name1}, {name2}, and {name3} in }
				=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in }
				other {{name1}, {name2}, {name3}, and {overflowContributorCount} others in }
			}{channelName} `,
		description:
			'The title of a GROUP_MEETING thread — shows contributor names and channel name without # prefix.',
	},
	externalPeopleLabel: {
		id: 'externalPeopleLabel',
		defaultMessage: 'External people #{channelName}',
		description: 'Label for external people in the search result title',
	},
	externalPersonLabel: {
		id: 'externalPersonLabel',
		defaultMessage: 'External person',
		description: 'Label for external person in the search result title',
	},
	unknownChannel: {
		id: 'search-result.unknown-channel-in-thread',
		defaultMessage: 'unknown-channel',
		description: 'Use to describe a channel when the name is not available',
	},
	directMessageSingleUser: {
		id: 'search-result.direct-message-single-user',
		defaultMessage: '{name1} and 1 other',
		description: 'Title for direct message with single user',
	},
	directMessageTwoUsers: {
		id: 'search-result.direct-message-two-users',
		defaultMessage: '{name1} and {name2}',
		description:
			"Heading shown in a direct message search result when the conversation is between exactly two users. The placeholder {name1} is substituted with the first user's display name and {name2} with the second user's display name.",
	},
	groupDirectMessageUnknownNames: {
		id: 'search-result.group-direct-message-unknown-names',
		defaultMessage: '{totalPeopleCount} people',
		description: 'Title for group direct message when no names are known',
	},
	federatedGroupDirectMessage: {
		id: 'search-result.federated-group-direct-message',
		// eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
		defaultMessage: ` {knownNamesCount, plural,
				=1 {{name1}}
				=2 {{name1} and {name2}}
				=3 {{name1}, {name2}, and {name3}}
				=4 {{name1}, {name2}, {name3}, and {name4}}
				other {{name1}, {name2}, {name3}, and {name4}}
			} `,
		description: 'Title for federated group direct message showing known names',
	},
	federatedGroupDirectMessageWithOneOther: {
		id: 'search-result.federated-group-direct-message-with-one-other',
		// eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
		defaultMessage: ` {knownNamesCount, plural,
				=1 {{name1} and {totalOthersCount} other}
				=2 {{name1}, {name2}, and {totalOthersCount} other}
				=3 {{name1}, {name2}, {name3}, and {totalOthersCount} other}
				=4 {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} other}
				other {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} other}
			} `,
		description: 'Title for federated group direct message showing known names and exactly 1 other',
	},
	federatedGroupDirectMessageWithMultipleOthers: {
		id: 'search-result.federated-group-direct-message-with-multiple-others',
		// eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
		defaultMessage: ` {knownNamesCount, plural,
				=1 {{name1} and {totalOthersCount} others}
				=2 {{name1}, {name2}, and {totalOthersCount} others}
				=3 {{name1}, {name2}, {name3}, and {totalOthersCount} others}
				=4 {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} others}
				other {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} others}
			} `,
		description: 'Title for federated group direct message showing known names and multiple others',
	},
});
